/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobListRequest {
    getFixupPrototypeFunction() { return TemplateJobListRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobListRequest>): TemplateJobListRequest {
        let obj = Object.assign(new TemplateJobListRequest(), model);
        TemplateJobListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobListRequest>): TemplateJobListRequest {
        if (!model) return null;
        return TemplateJobListRequest.newInstance(<TemplateJobListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobListRequest) {
        if (!obj) return;

        models.TemplateJobListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobListRequest): boolean {
        Object.setPrototypeOf(obj, TemplateJobListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.TemplateJobListFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.TemplateJobListSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.TemplateJobListSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.TemplateJobListFilter;

}
